import {useContext, useEffect, useState} from 'react'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import DrawerReservationInitialization from '@adv-mt/mt-drawer-reservation-initialization'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {useMessagingContext} from '../../../useMessagingContext/index.js'

export const ReservationMoreInfo = () => {
  const {domain} = useContext(Context)
  const {state, setInteractionComponent, setAdsDetails} = useMessagingContext()
  const {interactionUrl, adsDetails} = state
  const [isDrawerOpen, setIsDrawerOpen] = useState(true)
  const [drawerContent] = useState('reservationTerms')
  const [isLoadingAd, setIsLoadingAd] = useState(false)
  const {track} = useAnalyticsTrack()

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false)
    setInteractionComponent({component: null, show: false})
  }

  const {searchParams} = new URL(interactionUrl || '')
  const adId = searchParams.get('adId')

  useMount(() => {
    track({
      event: 'Reservation More Information Clicked',
      data: {hit_origin: 'system message', products: [{id: adId, category: 'ads', price: 0, quantity: 0}]}
    })
  })

  const adDetails = adsDetails[adId]
  const adDetail = adDetails?.ad

  useEffect(() => {
    const loadAdIfNeeded = async () => {
      if (adId && !adDetails && !isLoadingAd) {
        setIsLoadingAd(true)
        const [error, adsDetailsResponse] = await domain.get('get_ad_details_ads_use_case').execute({adId})
        if (!error) {
          setAdsDetails({
            ...adsDetails,
            [adsDetailsResponse.ad.id]: adsDetailsResponse
          })
        }
        setIsLoadingAd(false)
      }
    }

    loadAdIfNeeded()
  }, [adId])

  const adInfo = {
    id: adDetail?.id || adId || '',
    title: adDetail?.title || '',
    imageUrl: adDetail?.imgUrl || '',
    price: adDetail?.price || null,
    instalment: adDetails?.financingData?.fee,
    dealerRating: adDetails?.seller?.dealer?.ratings?.average || null,
    dealerName: adDetails?.seller?.dealer?.name || ''
  }

  return (
    <DrawerReservationInitialization
      adInfo={adInfo}
      isDrawerOpen={isDrawerOpen}
      onCloseDrawer={handleCloseDrawer}
      drawerContent={drawerContent}
    />
  )
}
